import React from 'react';
import { NavigationItem as StyledNavigationItem } from '../styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';

interface NavigationItemProps {
  iconName: string;
  onClick?: (e: React.SyntheticEvent) => void;
  width?: string;
  height?: string;
  viewBox?: string;
  fill?: string;
  disabled?: boolean;
}

const BottomNavigationItem: React.FC<NavigationItemProps> = ({
  iconName,
  onClick,
  width = '24',
  height = '24',
  viewBox = '0 0 18 18',
  fill = 'var(--text-secondary)',
  disabled = false
}) => {
  return (
    <StyledNavigationItem onClick={onClick} disabled={disabled}>
      <SVGIcon name={iconName} width={width} height={height} viewBox={viewBox} fill={fill} />
    </StyledNavigationItem>
  );
};

export default BottomNavigationItem;
